//
import GBranchOfficeModel from '@/models/General/GBranchOffice'


//
export default [
  {
    name: 'g_branch_office_id',
    type: 'model-auto-complete',
    vuetifyProps: {
      label: 'Sucursal',
      model: GBranchOfficeModel,
      itemText: 'name',
      itemValue: 'id',
      noObject: true,
      paramSearch: 'name',
    },
  },
  {
    field: 'init_date',
    type: 'datePicker',
    value: '',
    vuetifyProps: {
      label: 'Fecha de Inicio',
    },
  },
  {
    field: 'end_date',
    type: 'datePicker',
    value: '',
    vuetifyProps: {
      label: 'Fecha de Término',
    },
  },
]
